import "angular-busy/dist/angular-busy.css";
import "angular-toastr/dist/angular-toastr.css";
import "angular-ui-tree/dist/angular-ui-tree.css";
import "angular-wizard/dist/angular-wizard.css";
import "angular-xeditable/dist/css/xeditable.css";
import "angularjs-slider/dist/rzslider.css";
import "ui-select/dist/select.css";
// import "pikaday/css/pikaday.css";

import "../less/style.less";

import "../fonts/font-awesome/css/font-awesome.min.css";

import "expose-loader?exposes=jQuery,$!jquery";
import "expose-loader?exposes=agGrid!ag-grid-enterprise/dist/ag-grid-enterprise.min.js";
import "expose-loader?exposes=moment!moment";
import angular from "angular";
import "angular";
import "angular-chart.js";
import "angular-cookies";
import "angular-dynamic-locale";
import "angular-messages";
import "angular-resource";
import "angular-toastr";
import "angular-translate";
import "angular-translate-handler-log";
import "angular-translate-loader-static-files";
import "angular-translate-storage-cookie";
import "angular-translate-storage-local";
import "angular-ui-bootstrap";
import "angular-ui-router";
import "angular-ui-tree";
import "chart.js";
import "inter-common/CrossMessageCommunicationModule/CrossMessageCommunicationModule.js";
import "inter-common/InterflowErrors/InterflowErrorsModule.js";
import "inter-translate/DropdownTranslateModule/DropdownTranslateModule.js";
import "inter-translate/LocaleModule/LocaleModule.js";
import "ui-select";
// import "expose-loader?exposes=_!underscore";
import "angular-animate";
import "angular-busy";
import "angular-wizard";
import "angular-xeditable";
import "angularjs-slider";
import "blob-tmp";
import "file-saver";
import "moment-timezone/builds/moment-timezone-with-data-10-year-range.min.js";
import "ng-file-saver";
import "ng-file-upload";
import "numbro";
// import "signalr";

import "./register-modules";

import "./Services/dateService.ts";
import "./Services/debounce.ts";
import "./Services/dtpChartService.ts";
import "./Services/fileDownloadService.ts";
import "./Services/httpShowErrorInterceptor.ts";
import "./Services/localStorageService";
import "./Services/modalService.ts";
import "./Services/monthlyDataService.ts";
import "./Services/oracleDataService";
import "./Services/responseHandlerService.ts";
import "./Services/setLanguageInterceptor.ts";
import "./Services/synchronousEventsBus.ts";
import "./Services/toasterService.ts";
import "./Services/translationCacheService.ts";
import "./Services/uiGridScrollExtension.ts";
import "./Services/userManagerExtension";
import "./Services/vmiDataProvider.ts";
import "./Utils/commonJsUtils.ts";

import "./Components/buttonComponent.ts";
import "./Directives/contextMenu.ts";
import "./Directives/dragSelectDirectives.ts";
import "./Directives/enterAsTab.ts";
import "./Directives/indeterminateCheckbox.ts";
import "./Directives/ngHtmlCompile.ts";
import "./Directives/ngRightClick.ts";
import "./Directives/ngTitle.ts";
import "./Directives/numbFormatter.ts";
import "./Directives/tableExcelExport.ts";
import "./Directives/tableNavigation.ts";
import "./Directives/yearSelector.ts";
import "./Filters/join.ts";
import "./Filters/numberInMilionsFilter.ts";
import "./Filters/percent-filter.ts";
import "./Services/agGridService.ts";
import "./Services/angularExtensions.ts";
import "./Services/apiService.ts";
import "./Services/appConstant.ts";
import "./Services/clipboardService.ts";
// import "./Services/convertDateStringsToDates.ts";
import "./auth/idSrvAuthService";
import "./auth/tokenService.ts";
import "./Directives/validation/dateAfterOtherDateValidation.ts";
import "./Directives/validation/dateBeforeOtherDateValidation.ts";
import "./Directives/validation/forecastNameUniqueValidation.ts";
import "./Directives/validation/marketDefinitionNameUniqueValidation.ts";
import "./Directives/validation/marketNameUniqueValidation.ts";
import "./Directives/wizzard/stepIf.ts";
import "./Modules/BudgetVersions/budgetVersion.config.ts";
import "./Modules/BudgetVersions/budgetVersionDashboardCtrl.ts";
import "./Modules/Common/components/agGridPageSizeComponent.ts";
import "./Modules/Common/components/chamferComponent.ts";
import "./Modules/Common/components/changeProductManagerComponent.ts";
import "./Modules/Common/components/correctionAboutFactsBatchEditComponent.ts";
import "./Modules/Common/components/imsBrandFilterComponent.ts";
import "./Modules/Common/components/imsBrandSearchComponent.ts";
import "./Modules/Common/components/imsIoBrandFilterComponent.ts";
import "./Modules/Common/components/resumeFixedBoxComponent.ts";
import "./Modules/Common/services/chamferService.ts";
import "./Modules/Common/services/mlDataService.ts";
import "./Modules/Configuration/components/brandGroupNameComponent.ts";
import "./Modules/Configuration/components/forecastConfigEditComponent.ts";
import "./Modules/Configuration/components/marketBrandComponent.ts";
import "./Modules/Configuration/components/marketNameComponent.ts";
import "./Modules/Configuration/components/popups/brandGroupNameEditComponent.ts";
import "./Modules/Configuration/components/popups/forecastNameValueEditComponent.ts";
import "./Modules/Configuration/components/popups/marketNameEditComponent.ts";
import "./Modules/Configuration/components/productComponent.ts";
import "./Modules/Configuration/components/scoringCardSummaryComponent.ts";
import "./Modules/Configuration/configuration.ts";
import "./Modules/Configuration/controllers/configurationCtrl.ts";
import "./Modules/Configuration/services/brandGroupNameService.ts";
import "./Modules/Configuration/services/configurationPeriodService.ts";
import "./Modules/Configuration/services/countryService.ts";
import "./Modules/Configuration/services/forecastConfigurationService.ts";
import "./Modules/Configuration/services/marketBrandService.ts";
import "./Modules/Configuration/services/marketDefinitionService.ts";
import "./Modules/Configuration/services/productService.ts";
import "./Modules/Configuration/views/partial/forecast.ts";
import "./Modules/Configuration/views/partial/periods.ts";
import "./Modules/Forecast/components/assumptions/assumptionsCardComponent.ts";
import "./Modules/Forecast/components/assumptions/brandInfoComponent.ts";
import "./Modules/Forecast/components/assumptionsStepComponent.ts";
import "./Modules/Forecast/components/common/autoSaveComponent.ts";
import "./Modules/Forecast/components/common/brandSelection/brandSelection.ts";
import "./Modules/Forecast/components/common/cycleTable/cycleTableComponent.ts";
import "./Modules/Forecast/components/common/gridState/gridStateComponent.ts";
import "./Modules/Forecast/components/common/gridState/gridStateService.ts";
import "./Modules/Forecast/components/common/gridValueEditor/girdValudEditorHeader.ts";
import "./Modules/Forecast/components/common/gridValueEditor/gridValueEditorComponent.ts";
import "./Modules/Forecast/components/common/gridValueEditor/service/gridValueEditorService.ts";
import "./Modules/Forecast/components/common/newProductsSelectorComponent.ts";
import "./Modules/Forecast/components/common/imsIoNewProductsSelectorComponent.ts";
import "./Modules/Forecast/components/common/quarterTable/quarterTableComponent.ts";
import "./Modules/Forecast/components/common/statistics/cyclesSumChartComponent.ts";
import "./Modules/Forecast/components/common/statistics/quaterPpgTableComponent.ts";
import "./Modules/Forecast/components/common/statistics/quaterSumChartComponent.ts";
import "./Modules/Forecast/components/common/statistics/yearlyPpgTableComponent.ts";
import "./Modules/Forecast/components/common/statistics/yearlySumChartComponent.ts";
import "./Modules/Forecast/components/common/switchButton/switchButton.ts";
import "./Modules/Forecast/components/correctionAboutFactRollingForecastComponent.ts";
import "./Modules/Forecast/components/dashboards/createdForecastListComponent.ts";
import "./Modules/Forecast/components/dashboards/draftForecastListComponent.ts";
import "./Modules/Forecast/components/forecastBase/chamfering/chamferingSkuForecastComponent.ts";
import "./Modules/Forecast/components/forecastBase/correctionAboutFactsComponent.ts";
import "./Modules/Forecast/components/forecastBase/dtp-table.ts";
import "./Modules/Forecast/components/forecastBase/forecastAbsoluteDiferencesComponent.ts";
import "./Modules/Forecast/components/forecastBase/forecastMathFunctionComponent.ts";
import "./Modules/Forecast/components/forecastBase/PPG/calculationPPGComponent.ts";
import "./Modules/Forecast/components/forecastBase/skipPeriodsComponent.ts";
import "./Modules/Forecast/components/forecastBase/smoothDataComponent.ts";
import "./Modules/Forecast/components/forecastBase/volumeToValueTranslationComponent.ts";
import "./Modules/Forecast/components/forecastBaseComponent.ts";
import "./Modules/Forecast/components/forecastParametersComponent.ts";
import "./Modules/Forecast/components/plannerProductSearchComponent";
import "./Modules/Forecast/components/popups/forecastChangeProductCodeComponent.ts";
import "./Modules/Forecast/components/popups/forecastSaveAsNewComponent.ts";
import "./Modules/Forecast/components/popups/forecastSelectorPopUpComponent.ts";
import "./Modules/Forecast/components/popups/modalConfirm.ts";
import "./Modules/Forecast/components/popups/modalError.ts";
import "./Modules/Forecast/components/popups/saveGridStateComponent.ts";
import "./Modules/Forecast/components/productForecastComponent.ts";
import "./Modules/Forecast/components/productForecasts/chartTypeConfigComponent.ts";
import "./Modules/Forecast/components/productForecasts/historicalDataComponent.ts";
import "./Modules/Forecast/components/productForecasts/mkshr/mkshrInYearsEditorComponent.ts";
import "./Modules/Forecast/components/productForecasts/mkshrProductForecastComponent.ts";
import "./Modules/Forecast/components/productForecasts/productForecastChartComponent.ts";
import "./Modules/Forecast/components/productForecasts/productPpgChartComponent.ts";
import "./Modules/Forecast/components/productForecasts/rollingForecastChartAndTableComponent.ts";
import "./Modules/Forecast/components/productForecasts/sku/skuProductForecastComponent.ts";
import "./Modules/Forecast/components/productForecasts/skusChartAndTableComponent.ts";
import "./Modules/Forecast/components/selectionForecastComponent.ts";
import "./Modules/Forecast/components/skuForecastComponent.ts";
import "./Modules/Forecast/components/summary/absoluteDifferencesComponent.ts";
import "./Modules/Forecast/components/summary/defenceSummaryComponent.ts";
import "./Modules/Forecast/components/summary/mktshSummaryComponent.ts";
import "./Modules/Forecast/components/summary/pmforecastAndExFactoryComponent.ts";
import "./Modules/Forecast/components/summary/rotationAndStockComponent.ts";
import "./Modules/Forecast/components/summaryForecastComponent.ts";
import "./Modules/Forecast/forecast.config.ts";
import "./Modules/Forecast/forecastEditCtrl.ts";
import "./Modules/Forecast/forecastListCtrl.ts";
import "./Modules/Forecast/forecastMarketDumpCtrl.ts";
import "./Modules/Forecast/processComponents/chooseBudgetVersionComponent.ts";
import "./Modules/Forecast/processComponents/forecastHistory.component";
import "./Modules/Forecast/processComponents/forecastRejectComponent.ts";
import "./Modules/Forecast/processComponents/forecastSendToApprovalForceComponent.ts";
import "./Modules/Forecast/processComponents/forecastUpdateComponent.ts";
import "./Modules/Forecast/services/absoluteDifferencesService.ts";
import "./Modules/Forecast/services/calculationPPGservice.ts";
import "./Modules/Forecast/services/chamfering/chamferingBrandCalculationService.ts";
import "./Modules/Forecast/services/chamfering/chamferingCorrectionAboutFactsForecastService.ts";
import "./Modules/Forecast/services/chamfering/chamferingSkuCalculationService.ts";
import "./Modules/Forecast/services/charts.config.ts";
import "./Modules/Forecast/services/exFactoryCalculationService.ts";
import "./Modules/Forecast/services/exFactoryService.ts";
import "./Modules/Forecast/services/forecastApprovalService.ts";
import "./Modules/Forecast/services/forecastGridService.ts";
import "./Modules/Forecast/services/forecastMLModelUpdateService.ts";
import "./Modules/Forecast/services/forecastParametersProvider.ts";
import "./Modules/Forecast/services/forecastProcessService.ts";
import "./Modules/Forecast/services/forecastReportService.ts";
import "./Modules/Forecast/services/forecastService.ts";
import "./Modules/Forecast/services/initializeAndRefresh/chamferingForecasInitService.ts";
import "./Modules/Forecast/services/initializeAndRefresh/forecastInitializationService.ts";
import "./Modules/Forecast/services/initializeAndRefresh/imsDataCommonService.ts";
import "./Modules/Forecast/services/initializeAndRefresh/imsDataService.ts";
import "./Modules/Forecast/services/mkshr/brandCalculationService.ts";
import "./Modules/Forecast/services/mkshr/mkrshCalculatorService.ts";
import "./Modules/Forecast/services/mkshr/mktshSummaryCalculation.ts";
import "./Modules/Forecast/services/mkshr/ppgCalculationService.ts";
import "./Modules/Forecast/services/mkshr/skuCalculationService.ts";
import "./Modules/Forecast/services/plannerProductSearchService.ts";
import "./Modules/Forecast/services/ppgChartAndTableService.ts";
import "./Modules/Forecast/services/pricesLoad/priceListLoadService";
import "./Modules/Forecast/services/pricesLoad/scoringCardPriceLoadService.ts";
import "./Modules/Forecast/services/selectElementAndConvertService.ts";
import "./Modules/Forecast/services/sku/skuMktShrService.ts";
import "./Modules/Forecast/services/sku/skuValueVolumeService.ts";
import "./Modules/Forecast/services/steps/correctionAboutFactsService.ts";
import "./Modules/Forecast/services/steps/forecastCacheService.ts";
import "./Modules/Forecast/services/steps/freezedMonthsService.ts";
import "./Modules/Forecast/services/steps/initializeHubService.ts";
import "./Modules/Forecast/services/steps/mathFunctionService.ts";
import "./Modules/Forecast/services/steps/pmForecastService.ts";
import "./Modules/Forecast/services/steps/regressionCalculator.ts";
import "./Modules/Forecast/services/steps/skipPeriodsService.ts";
import "./Modules/Forecast/services/steps/smoothData-service.ts";
import "./Modules/Forecast/services/steps/volumeToValueService.ts";
import "./Modules/Forecast/services/stepValidationService.ts";
import "./Modules/Market/components/fileValidationErrorsComponent.ts";
import "./Modules/Market/components/fileMarketAvailableProductsComponent.ts";
import "./Modules/Market/components/marketCloneComponent.ts";
import "./Modules/Market/components/marketDefinitionEditComponent.ts";
import "./Modules/Market/components/marketExportComponent.ts";
import "./Modules/Market/components/marketFiltersComponent.ts";
import "./Modules/Market/components/marketFinishValidationComponent.ts";
import "./Modules/Market/components/fileMarketValueComponent";
import "./Modules/Market/components/fileMarketSkusComponent";
import "./Modules/Market/components/marketNewProductsComponent.ts";
import "./Modules/Market/components/fileMarketNewProductsComponent.ts";
import "./Modules/Market/components/marketSkusComponent.ts";
import "./Modules/Market/components/marketValueComponent.ts";
import "./Modules/Market/market.config.ts";
import "./Modules/Market/marketDefinitionListCtrl.ts";
import "./Modules/Market/marketEditController.ts";
import "./Modules/Market/marketInternationalEditCtrl.ts";
import "./Modules/Market/marketListController.ts";
import "./Modules/Market/marketScoringCardsEditCtrl.ts";
import "./Modules/Market/marketScoringCardsPolandEditCtrl.ts";
import "./Modules/Market/services/initializeReportHubService.ts";
import "./Modules/Market/services/internationaMarketFileService.ts";
import "./Modules/Market/services/marketContentReportService.ts";
import "./Modules/Market/services/marketDataProvider.ts";
import "./Modules/Market/services/marketEditService.ts";
import "./Modules/Market/services/marketFinishValidationService.ts";
import "./Modules/ProductOwners/components/productOwnerAssignmentsComponent.ts";
import "./Modules/ProductOwners/components/productsAssignmentComponent.ts";
import "./Modules/ProductOwners/productOwners.component.ts";
import "./Modules/ProductOwners/productOwners.config.ts";
import "./Modules/ScoringCards/components/scoringCardForecasts.component";
import "./Modules/ScoringCards/components/scoringCardsReport.component";
import "./Modules/ScoringCards/scoringCards.config.ts";
import "./Modules/Unauthorized/unauthorized.config.ts";

import "../images/silver-icon/topline.png";

import "./register-app-insights";

import "./app.config";
import { IdServerPreAuth } from "./auth/idServerPreAuth";

function startApp() {
    // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'agGrid'.
    agGrid.LicenseManager.setLicenseKey(
        "CompanyName=Silvermedia Qlogix Sp. z o.o.,LicensedGroup=Silvermedia S.A,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,ExpiryDate=24_February_2021_[v2]_MTYxNDEyNDgwMDAwMA==e06144baa05abb087f673f9f38ef1a8b"
    );
    // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'agGrid'.
    agGrid.initialiseAgGridWithAngular1(angular);

    angular.bootstrap(document, ["topline.app"]);
}

const authServer = new IdServerPreAuth({
    onSuccessCallback: startApp
});

authServer.signIn();
